/* Refresh from the theme's own variant response; never infer stock from a random value. */
if (!customElements.get('novelle-variant-message')) {
  customElements.define('novelle-variant-message', class extends HTMLElement {
    connectedCallback() {
      this.productSection = this.closest('[id^="MainProduct-"]');
      this.onSelection = (event) => {
        if (event.target.closest('variant-selects, variant-radios')) this.hidden = true;
      };
      this.productSection?.addEventListener('change', this.onSelection);
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.section) return;
        const source = data.html.getElementById(`${this.dataset.prefix}-${data.sectionId}`);
        if (!source) { this.hidden = true; return; }
        this.innerHTML = source.innerHTML;
        this.hidden = source.hidden;
      });
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.productSection?.removeEventListener('change', this.onSelection);
    }
  });
}
